import { SingleUserFieldFilter } from 'module/types/filter-field/filter/single-user';
import { FC, useMemo } from 'react';
import { SingleSelectBaseCriteria } from './single-select-base';
import { UserEditorComponents } from '../../field-editors/default-editor-components';
import { EditorComponents } from '../../field-editors/types';
import { UserOptionsGetter } from '../types';

interface Props {
  filter: SingleUserFieldFilter;
  onChange: (filter: SingleUserFieldFilter) => void;
  optionsGetter?: UserOptionsGetter;
  components?: EditorComponents;
}

export const SingleUserCriteria: FC<React.PropsWithChildren<Props>> = ({
  filter,
  onChange,
  optionsGetter,
  components,
}) => {
  const options = useMemo(
    () =>
      optionsGetter != null
        ? optionsGetter(filter.field)
        : (filter.field.metaData.options ?? []),
    [filter.field, optionsGetter],
  );

  return (
    <SingleSelectBaseCriteria
      components={{
        ...UserEditorComponents,
        ...components,
      }}
      filter={filter}
      onChange={onChange as any}
      options={options}
      type="user"
    />
  );
};
